import React from 'react'

export const SubscriptionPlans = () => {
  return (
    <div>SubscriptionPlans</div>
  )
}
